<template>
  <q-page>
    <div v-if="integration">
      <div v-if="ialocIntegration">
        <div class="be-page-title q-mt-md q-mb-md" v-html="$t('reservations.title')"></div>
        <div id="ialocWidgetContainer" class="q-mt-md" style="margin: 16px auto 0"></div>
      </div>
      <div v-else class="be-main-lr q-mt-lg" style="max-width: 750px; margin: 0 auto">
        <div class="be-page-title q-mt-md q-mb-md" v-html="$t('reservations.title')"></div>
        <form>
          <q-select
            v-model="form.store_id"
            outlined
            emit-value
            map-options
            options-dense
            dense
            :options="stores"
            option-label="name"
            option-value="id"
            @update:model-value="updateStore"
          />
          <div class="row">
            <div class="col" style="align-self: center">{{ $t('reservations.over-phone') }}: {{ store.phone }}</div>
            <div class="col-auto">
              <q-btn
                icon="app:contact"
                class="be-btn-s be-icon-24 bg-accent q-mt-md q-mb-md"
                :href="`tel:${store.phone}`"
              />
            </div>
          </div>
          <q-input
            v-model="form.name"
            name="name"
            type="text"
            outlined
            dense
            class="be-input-no-shadow"
            :error="$hasError(errors, 'name')"
            :error-message="$showError(errors, 'name')"
            :placeholder="$t('fields.your-name')"
            @keydown.enter="focusNext"
          />
          <div class="row q-col-gutter-sm">
            <div class="col-auto">
              <q-select
                v-model="form.phone_country"
                name="phone_country"
                outlined
                dense
                emit-value
                map-options
                options-dense
                bottom-slots
                option-value="code"
                option-label="name"
                :options="countries"
                class="be-input-no-shadow be-icon-12 be-text-sm"
                :error="$hasError(errors, 'phone_country')"
                :error-message="$showError(errors, 'phone_country')"
              >
                <template #selected-item="scope">
                  <q-img
                    :src="'https://assets.boosteat.com/shop-images/countries/' + scope.opt.code.toLowerCase() + '.png'"
                    loading="eager"
                    style="width: 27px"
                  />
                </template>
              </q-select>
            </div>
            <div class="col">
              <q-input
                v-model="form.phone"
                name="phone"
                type="tel"
                outlined
                dense
                class="be-input-no-shadow"
                :placeholder="$t('fields.phone')"
                :error="$hasError(errors, 'phone')"
                :error-message="$showError(errors, 'phone')"
                @keydown.enter="focusNext"
              />
            </div>
          </div>
          <q-input
            v-model="form.email"
            type="email"
            name="email"
            outlined
            dense
            class="be-input-no-shadow"
            :error="$hasError(errors, 'email')"
            :error-message="$showError(errors, 'email')"
            :placeholder="$t('fields.email')"
            @keydown.enter="focusNext"
          />
          <q-select
            v-model="form.no_of_persons"
            dense
            outlined
            options-dense
            class="be-input-no-shadow"
            :label="form.no_of_persons === null ? $t('fields.no-of-persons') : void 0"
            :error="$hasError(errors, 'no_of_persons')"
            :error-message="$showError(errors, 'no_of_persons')"
            :options="persons"
          />
          <q-select
            v-if="storeEvents.length > 0"
            v-model="form.store_event_id"
            dense
            outlined
            options-dense
            class="be-input-no-shadow"
            emit-value
            map-options
            option-value="id"
            option-label="name"
            :label="form.store_event_id === null ? $t('fields.event') : void 0"
            :error="$hasError(errors, 'store_event_id')"
            :error-message="$showError(errors, 'store_event_id')"
            :options="storeEvents"
            clearable
          />
          <div class="row q-col-gutter-sm">
            <div class="col">
              <q-select
                v-model="form.day"
                outlined
                emit-value
                map-options
                dense
                options-dense
                :options="days"
                :label="form.day === null ? $t('fields.day') : void 0"
                class="be-input-no-shadow"
                :error="$hasError(errors, 'day')"
                :error-message="$showError(errors, 'day')"
                @update:model-value="updateDay"
              />
            </div>
            <div class="col">
              <q-select
                v-model="form.time"
                dense
                outlined
                emit-value
                map-options
                options-dense
                :options="times"
                :label="form.time === null ? $t('fields.hour') : void 0"
                class="be-input-no-shadow"
                :error="$hasError(errors, 'time')"
                :error-message="$showError(errors, 'time')"
              />
            </div>
          </div>
          <q-input
            v-model="form.message"
            type="textarea"
            autogrow
            outlined
            dense
            class="be-input-no-shadow"
            :error="$hasError(errors, 'message')"
            :error-message="$showError(errors, 'message')"
            :placeholder="$t('fields.your-message')"
          />
          <q-btn
            flat
            class="be-btn-xl bg-black text-white full-width q-mb-md"
            :label="$t('buttons.send')"
            @click="saveReservation"
          />
        </form>
      </div>
    </div>
  </q-page>
</template>

<script>
import { createMetaMixin } from 'quasar'
import countries from '../assets/countries.json'

import { mapState } from 'pinia'
import { useSettingsStore } from 'stores/settings'
import { useCartStore } from 'stores/cart'

export default {
  name: 'ReservationsPage',
  mixins: [
    createMetaMixin(function mymeta() {
      return {
        title: `${this.$t('reservations.title')} - ${this.websiteName}`,
        meta: {
          description: {
            name: 'description',
            content: `${this.$t('reservations.title')} - ${this.websiteName}`
          }
        }
      }
    })
  ],
  data() {
    return {
      form: {
        store_id: null,
        name: null,
        phone: null,
        phone_country: null,
        email: null,
        no_of_persons: null,
        store_event_id: typeof this.$route.query.event_id !== 'undefined' ? Number(this.$route.query.event_id) : null,
        day: null,
        time: null,
        message: null
      },
      ialocIntegration: false,
      integration: false,
      countries,
      days: [],
      times: [],
      persons: [],
      storeEvents: [],
      timeoutId: null,
      errors: {}
    }
  },
  computed: {
    ...mapState(useCartStore, {
      storeId: store => store.store_id
    }),
    ...mapState(useSettingsStore, {
      countryCode: store => store.localization.country_code,
      stores: store => store.stores,
      websiteName: store => store.website.name
    }),
    store() {
      const storeIndex = this.stores.map(item => item.id).indexOf(this.form.store_id)
      if (storeIndex !== -1) {
        return this.stores[storeIndex]
      }
      return this.stores[0]
    }
  },
  beforeUnmount() {
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId)
    }
  },
  mounted() {
    this.form.store_id = this.storeId
    this.form.phone_country = this.countryCode
    for (let i = 1; i < 15; i++) {
      this.persons.push(i)
    }
    this.checkIntegrations()
  },
  methods: {
    checkIntegrations() {
      this.$axios.get('public/integrations/reservation').then(response => {
        if (response.data.integrations.length !== 0) {
          this.ialocIntegration = true // Set flag to true if ialoc integration exists
          response.data.integrations.forEach(integration => {
            switch (integration.provider) {
              case 'ialoc.ro':
                this.ialocIntegration = true // Set flag to true if ialoc integration exists
                this.integration = true
                if (typeof ialocEmbedWidget === 'undefined') {
                  !(function (e, t, i, n, s, o, c, a, d, r) {
                    if (!e[n]) {
                      for (; a < c.length; ) s(o, c[a++])
                      ;((d = t.createElement(i)).async = 1),
                        (d.src = 'https://ialoc.ro/assets/widget-v2/embed.min.js'),
                        (r = t.getElementsByTagName(i)[0]).parentNode.insertBefore(d, r),
                        (e[n] = o)
                    }
                  })(
                    window,
                    document,
                    'script',
                    'ialocEmbedWidget',
                    (e, t) => {
                      e[t] = function () {
                        e._q.push([t, arguments])
                      }
                    },
                    { _q: [] },
                    'init show hide'.split(' '),
                    0
                  )
                }
                this.timeoutId = setTimeout(() => {
                  var widgetOptions = {
                    source: 'ialoc-widget-embed',
                    locale: 'ro', // ro / en
                    embedMode: 'inline',
                    venueId: integration.public_arg1,
                    onWidgetReady() {
                      ialocEmbedWidget.show()
                    }
                  }
                  ialocEmbedWidget.init(widgetOptions)
                }, 1)
                break
              default:
                this.integration = true
                this.updateStore()
            }
          })
        } else {
          this.integration = true
          this.updateStore()
        }
      })
    },
    saveReservation() {
      this.$axios
        .post('public/reservations', this.form)
        .then(response => {
          if (response.data.status === 'OK') {
            if (this.$q.localStorage.has('be_cookie_consent')) {
              try {
                const acceptedCookies = this.$q.localStorage.getItem('be_cookie_consent')
                const trackers = this.$store.state.settings.trackers
                Object.keys(trackers).forEach(type => {
                  if (type === 'fbpixel' && acceptedCookies.marketing) {
                    fbq('track', 'Schedule')
                  }
                })
              } catch (err) {
                // to do
              }
            }
            this.$router.push('/reservations/thank-you')
            this.form = {
              store_id: this.storeId,
              name: null,
              phone: null,
              email: null,
              phone_country: this.countryCode,
              no_of_persons: null,
              store_event_id: null,
              day: null,
              time: null,
              message: null
            }
          }
        })
        .catch(error => {
          if (typeof error.response !== 'undefined' && error.response.status === 422) {
            this.errors = error.response.data.errors
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
          }
        })
    },
    updateStore() {
      this.$axios.get(`public/reservations/days?store_id=${this.form.store_id}`).then(response => {
        if (response.data.status === 'OK') {
          this.days = response.data.days
        } else {
          this.days = []
        }
      })
      this.$axios.get(`public/store-events?store_id=${this.form.store_id}`).then(response => {
        this.storeEvents = response.data.store_events
      })
    },
    updateDay() {
      this.$axios.get(`public/reservations/times/${this.form.day}?store_id=${this.form.store_id}`).then(response => {
        if (response.data.status === 'OK') {
          this.times = response.data.times
        } else {
          this.times = []
        }
      })
    },
    focusNext(e) {
      const inputs = Array.from(e.target.form.querySelectorAll('input'))
      const index = inputs.indexOf(e.target)
      if (index < inputs.length - 1) {
        inputs[index + 1].focus()
      }
    }
  }
}
</script>
